module.exports = __webpack_public_path__ + "static/braid-788646d4c76f2b92f10ed0a694ec3b31.png";